

<auslroma-login *ngIf="login_selected === 'AUSLROMA'">

</auslroma-login>

<!-- <div fxLayout="row" >
  <div fxFlex="50" fxFlexOffset="25">
    <mat-card class="card login-card">
        <mat-card-header class="card-header"  [ngStyle] = "getHeaderColor()" >
          <mat-card-title >
              <div class="header-title">
                <img class="logo" src="assets/static/logo_customer.png" style="float:left;" /> 
                <span  [style.color]="getTextColor()"> {{ getSettingValue('software_name') }} </span> 
              </div>
          </mat-card-title>
        </mat-card-header>
        
        <mat-card-content class="card-content" >
          <form (keyup.enter)="login()">
            <p>
              <mat-form-field class="full-width-field">
                <mat-label>Username</mat-label>
                <input  matInput  type="text" placeholder="username" [(ngModel)]="user.username" name="username"  required>
                <span matPrefix><mat-icon>account_circle</mat-icon> &nbsp;&nbsp;</span>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="full-width-field">
                <mat-label>Password</mat-label>
                <input  matInput type="password" [(ngModel)]="user.password" name="password"  required>
                <span matPrefix><mat-icon>vpn_key</mat-icon> &nbsp;&nbsp;</span>
              </mat-form-field>
            </p>
            <p *ngIf="isRememberMeAvailable()">
                <mat-checkbox [(ngModel)]="remember_me" name="remember_me"> {{ "generic.remember_me" | translate }}</mat-checkbox>
            </p>
  	    <div *ngIf="errors">
              <p class="errv red">{{ error_message | translate }}</p>
              <ng-container>
                <span *ngIf="error_detailed_message">
                    <span (click)="detail_expanded = true" class="pointer linked-inside">{{ 'buttons.read_more' | translate }} &#x25BC;</span>
                    <br><span class="errv red" *ngIf="detail_expanded == true">{{error_detailed_message | translate }}</span>
                </span>		    
              </ng-container>		
          </div>
          </form>
        </mat-card-content>
        <mat-card-actions class="card-actions">
              <button mat-button color="primary" class="login-button" (click)="login()">LOGIN</button>
        </mat-card-actions>
    </mat-card>
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  </div>
</div> -->
